module.exports = {
  PENDING: 'PENDING',
  OVERDUE: 'OVERDUE',
  COMPLETED: 'COMPLETED'
}
